import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import JobStatusChip from '@/components/tickets/JobStatusChip.vue'
import { NO_APPROVAL } from '@/models/job'
import JobCardLocationsDetail from '@/components/jobs/JobCardLocationsDetail.vue'
import { formatTimeRange } from '@/utils/date-formatting'
import moment from 'moment'
import { priorities } from '@/utils/constants'
import { RouterLinkProps } from 'vue-router/types/router'
import { useStore } from 'vuex-composition-helpers'
import LineItemsCard from '@/components/jobs/line-items/LineItemsCard.vue'
import VsCard from '@/components/vision/VsCard.vue'
import VsText from '@/components/vision/VsText.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import Company from '@/models/company'
import { Asset } from '@/models/asset'
import { JobSearchResponse } from '@/models/types/job-search-response'

type RouterLinkTo = RouterLinkProps['to']


export default /*#__PURE__*/_defineComponent({
  __name: 'JobCard',
  props: {
    job: null,
    linkTo: null,
    showCheckbox: { type: Boolean },
    isSelected: { type: Boolean },
    showLineItems: { type: Boolean },
    showAssignedToServiceProviderName: { type: Boolean }
  },
  emits: ["selected", "deselected"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'selected', selectedJob: JobSearchResponse)
  (e: 'deselected', unselectedJob: JobSearchResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  job: JobSearchResponse
  linkTo: RouterLinkTo
  showCheckbox: boolean
  isSelected: boolean
  showLineItems?: boolean
  showAssignedToServiceProviderName?: boolean
}



const store = useStore()



const company = computed(() => {
  return store.getters['companies/getByChildHubId'](props.job?.hub_id)
})
const jobTitle = computed(
  () => `Job #${props.job?.number} · ${company.value?.shortCode}`
)
const getCompanyByOrgId = computed<(orgId: string | null) => Company>(
  () => store.getters['companies/getByOrganizationId']
)
const assignedToServiceProviderName = computed(
  () => getCompanyByOrgId.value(props.job.assigned_service_provider_id)?.name
)

const priority = computed(() =>
  priorities.find((p) => p.name === props.job.priority)
)

const selected = computed({
  get() {
    return props.isSelected
  },
  set(selectedValue) {
    if (selectedValue) {
      selectJob(props.job)
    } else {
      deselectJob(props.job)
    }
  },
})

const scheduleTime = computed(() => {
  const startTime =
    props.job.requested_start && moment.utc(props.job.requested_start).local()
  const endTime =
    props.job.requested_end && moment.utc(props.job.requested_end).local()
  return formatTimeRange(startTime, endTime)
})

const finalStatus = computed(() =>
  props.job.approval_status !== null &&
  props.job.approval_status !== NO_APPROVAL
    ? props.job.approval_status
    : props.job.status.trim()
)

const getInventoryTypeById = computed<(id: number) => Asset>(
  () => store.getters['assets/getById']
)

const inventory = computed(() => {
  return props.job.inventory_requirements.map((inv) => ({
    name: getInventoryTypeById.value(inv.inventory_type_id)?.name,
    inventoryTypeId: inv.inventory_type_id,
    inventorySubTypeName: inv.name,
    inventorySubTypeId: inv.inventory_sub_type_id,
    quantity: inv.quantity,
    pickupLocationId: inv.pickup_location_id,
    pickupLocationName: inv.pickup_location_name,
    inventoryId: 0, // Not used
    position: inv.position,
    assetConditions: [], // Not used
  }))
})

const taskText = computed(() => {
  const assignment = props.job.assigned_resource_name || 'Unassigned'
  return `${props.job.resource_type_name} · ${assignment}`
})

function selectJob(job: JobSearchResponse) {
  emit('selected', job)
}

function deselectJob(job: JobSearchResponse) {
  emit('deselected', job)
}

return { __sfc: true,props, store, emit, company, jobTitle, getCompanyByOrgId, assignedToServiceProviderName, priority, selected, scheduleTime, finalStatus, getInventoryTypeById, inventory, taskText, selectJob, deselectJob, JobStatusChip, JobCardLocationsDetail, LineItemsCard, VsCard, VsText, VsHeading }
}

})